import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { apmKeyQrphKey } from "../../constants/common.c";
import { useFullWidthWalletButton } from "../hooks/useFullWidthWalletButton";
import { useQrphQr, QrphQrResult } from "./hooks/useQrphQr";
import "./style.css";

export type { QrphQrResult };

type DasQrphButtonProps = {
  apiData: any;
  slug: string;
  setDasLoader: (v: boolean) => void;
  setAmountPopup: (fn: any) => void;
  onQrGenerated: (qr: QrphQrResult) => void;
  navigate: any;
};

export const DasQrphButton = ({
  apiData,
  slug,
  setDasLoader,
  setAmountPopup,
  onQrGenerated,
  navigate,
}: DasQrphButtonProps) => {
  const { t } = useTranslation();
  const isFullWidthButton = useFullWidthWalletButton(apiData, apmKeyQrphKey);
  const { requestQr } = useQrphQr({
    apiData,
    slug,
    setDasLoader,
    setAmountPopup,
    onQrGenerated,
    navigate,
  });

  useEffect(() => {
    localStorage.setItem("slug", slug);
  }, [slug]);

  return (
    <button
      type="button"
      className={
        isFullWidthButton
          ? "qrph-button full-width-button"
          : "qrph-button"
      }
      onClick={requestQr}
    >
      {t("merchant.button.QrphQR")}
    </button>
  );
};

export default DasQrphButton;
